<template>
    <v-dialog max-width="600px"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      v-model="show" persistent
      v-on:click:outside="CancelDialog"
      >
      <v-card class="rounded-card">
        <v-system-bar color="teal" height="60px">
           <span class="headline font-weight-bold ms-2"> {{title}}</span>
        </v-system-bar>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 sm6>
              <v-text-field v-if="isNewGroup" :label="$t('Group Code')" v-model="grp.code" ></v-text-field>
              <v-text-field v-else :label="$t('Group Code')" v-model="grp.code" readonly color="grey"></v-text-field>
            </v-flex>
            <v-flex v-if="$vuetify.breakpoint.smAndUp" sm2 ></v-flex>
            <v-flex xs12 sm4>
              <v-switch v-model="grp.active" :label="$t('Active')" color="primary" class="ps-3"></v-switch>
            </v-flex>
          </v-layout>
              <v-text-field class="py-0" :label="$t('Group Name')" v-model="grp.name"></v-text-field>
          <v-layout wrap>
            <v-flex xs12 sm8>
              <v-select flat class="pe-1 py-0" :items="dropdown_group_type" v-model="grp.groupType"
                :label="$t('Group Type')" editable item-value="value">
              </v-select>
            </v-flex>
              <v-flex xs12 sm4>
              <v-text-field class="ps-2 py-0" :label="$t('Cows Count')" v-model.number="grp.cowCount"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs3>
              <v-tooltip top>
                <template v-slot:activator="{on}">
                  <p v-on="on" class="caption px-1 py-0">
                    {{$t('Daily Delivery Factor')}}
                  </p>
              </template>
            <span>
              {{$t('Daily delivery factor for each day of the week')}}
              <!-- <br /> (i.e. setting 1.5 will multiply the daily quantity plan for the group by 1.5)<br />
              It is usually used to deliver some of the next day quantity today (the total for the week should be 7) -->
              </span>
          </v-tooltip>
            </v-flex>
            <v-flex xs6>
              <p v-if="total7Rule != 7" class="caption px-1 error--text">
                {{$t('The total weekly factor should be 7') + "! [" + total7Rule +"]"}}
              </p>
            </v-flex>
          </v-layout>
          <v-layout wrap class="py-0">
            <v-flex xs2 sm1>
              <v-text-field type="number" step="0.25" min="0" max="7" :label="$t('Sun')" v-model.number=grp.weeklyDelivery[0] class="pl-1"></v-text-field>
            </v-flex>
            <v-flex xs2 sm1>
              <v-text-field type="number" step="0.25" min="0" max="7" :label="$t('Mon')" v-model.number=grp.weeklyDelivery[1] class="pl-1"></v-text-field>
            </v-flex>
            <v-flex xs2 sm1>
              <v-text-field type="number" step="0.25" min="0" max="7" :label="$t('Tue')" v-model.number=grp.weeklyDelivery[2] class="pl-1"></v-text-field>
            </v-flex>
            <v-flex xs2 sm1>
              <v-text-field type="number" step="0.25" min="0" max="7" :label="$t('Wed')" v-model.number=grp.weeklyDelivery[3] class="pl-1"></v-text-field>
            </v-flex>
            <v-flex xs2 sm1>
              <v-text-field type="number" step="0.25" min="0" max="7" :label="$t('Thu')" v-model.number=grp.weeklyDelivery[4] class="pl-1"></v-text-field>
            </v-flex>
            <v-flex xs2 sm1>
              <v-text-field type="number" step="0.25" min="0" max="7" :label="$t('Fri')" v-model.number=grp.weeklyDelivery[5] class="pl-1"></v-text-field>
            </v-flex>
            <v-flex xs2 sm1>
              <v-text-field type="number" step="0.25" min="0" max="7" :label="$t('Sat')" v-model.number=grp.weeklyDelivery[6] class="pl-1"></v-text-field>
            </v-flex>
            <v-flex xs4 sm1 ></v-flex>
            <v-flex xs6 sm4>
              <v-text-field :label="$t('Hunger')+' %'" v-model.number="grp.hungerPercent" class="ps-2"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs7>
                <v-select flat class="pe-1 py-0" :items="dropdown_tmrs"
                  v-model="grp.defaultTMR.code"
                  :label="$t('Default TMR')" editable
                  :rules="[(v) => !!v || $t('A default TMR should be selected')]"
                  >
                </v-select>
            </v-flex>
            <v-flex v-if="$vuetify.breakpoint.smAndUp" sm1 ></v-flex>
            <v-flex xs4>
                <v-text-field type="number" step="5" min="0" max="100"
                  v-model.number="grp.defaultTMR.dailyPercent"
                  @change="grp.secondTMR.dailyPercent = (100 - grp.defaultTMR.dailyPercent)"
                  :label="$t('Daily Percent')" class="px-1 py-0"
                >
                </v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs7>
                <v-select flat class="pe-1 py-0" :items="dropdown_tmrs"
                  v-model="grp.secondTMR.code"
                  :label="$t('Secondary TMR')" editable clearable
                  >
                </v-select>
            </v-flex>
            <v-flex v-if="$vuetify.breakpoint.smAndUp" sm1 ></v-flex>
            <v-flex xs4>
                <v-text-field type="number" step="5" min="0" max="100"
                  v-model.number="grp.secondTMR.dailyPercent"
                  @input="grp.defaultTMR.dailyPercent = (100 - grp.secondTMR.dailyPercent)"
                  :label="$t('Daily Percent')" class="px-1 py-0"
                >
                </v-text-field>
            </v-flex>
          </v-layout>
          <v-textarea rows=2 :label="$t('Operator Note')" no-resize persistent-hint counter=250
            :hint="$t('This note will be shown to operator before unloading')"
            v-model="grp.opNote" class="py-0">
          </v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-tooltip top v-if="group_id">
            <template v-slot:activator="{on}">
              <v-btn icon large color="primary" v-on="on" @click.stop="DeleteGroup">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>{{$t('Delete This Group')}}</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{on}">
              <v-btn icon color="primary" v-on="on" @click.stop="CancelDialog" class="mx-2" >
                <v-icon>mdi-cancel</v-icon>
              </v-btn>
            </template>
            <span>{{$t('Cancel') + " " +  $t('exit without saving')}}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{on}">
              <v-btn icon large color="primary" v-on="on" @click.stop="SaveGroup" class="mx-2">
                <v-icon>mdi-content-save</v-icon>
              </v-btn>
            </template>
            <span>{{$t('Save Group')}}</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import _ from "lodash";
export default {
    name:
        "AddEditGroupDialog",
    props: {
        value: Boolean,
        groupId: String
    },
    data() {
    return {
      group_id: this.groupId,
      grp: {}
    };
  },
  computed: {
    show: {
        get () {
            return this.value
        },
        set (value) {
            this.$emit("input", value);
            //this.value = value;
        }
    },
    dropdown_group_type() {
      return this.$store.getters.getGroupTypesForDD
    },
    title() {
      return (this.grp && this.grp.Id) ? this.$i18n.t('Edit Group') + " " + this.grp.code  + " - " + this.grp.name :this.$i18n.t('New Group');
    },
    isNewGroup() {
      return (this.grp && this.grp.Id) == null;
    },
    dropdown_tmrs() {
      return  this.$store.getters.getTMRs
      .filter(function(x) {
        return x.premixkey == undefined || x.premixkey == null || x.premixkey == "" && x.inactive == false
      })
      .map(function(x) {
        return { text: x.code + " - " + x.name, value: x.code }
      });
    },
    total7Rule() {
      return this.grp.weeklyDelivery.reduce((a, b) => a + Number(b), 0)
    },
    totalTMRule() {
      let ttl = this.grp.defaultTMR.dailyPercent*1 + this.grp.secondTMR.dailyPercent*1
      return Number(ttl) == 100 || this.$i18n.t('Total daily should be 100_')
    },
    tmrs() {
      return [this.grp.defaultTMR, this.grp.secondTMR];
    }
  },

methods: {
    CancelDialog() {
      if (this.groupId)
        this.grp = _.cloneDeep(this.$store.getters.getGroup(this.group_id));
      this.show = false;
      this.$emit("close");
    },
    SaveGroup() {
      if (!this.grp.defaultTMR)
        this.grp.defaultTMR = { code: null, dailyPercent: 100};
      if (!this.grp.secondTMR)
        this.grp.secondTMR = { code: null, dailyPercent: 0};
      this.grp.secondTMR.code = this.grp.secondTMR.code || null;

      if (this.grp.secondTMR.dailyPercent > 0 && this.grp.secondTMR.code == null) {
        this.$root.$globalSnackbar(this.$i18n.t('Must specify Second TMR or set the Second Daily Percent to 0'), "error")
        return
      }
      if (!this.grp.defaultTMR.code || this.grp.defaultTMR.code == null)
        this.$root.$globalSnackbar(this.$i18n.t('Must specify Default TMR'), "warning")
      else if (this.grp.cowCount == 0)
        this.$root.$globalSnackbar(this.$i18n.t('When the group has no Cows, no food will be plan for it'), "warning")

        this.grp.translatedGroupType = this.$i18n.t(this.grp.groupType);
        var payload = {Id: this.group_id, ...this.grp}
        this.$store.dispatch("saveGroup", payload);
        this.show = false;
        this.$emit("close");
    },
    DeleteGroup() {
      if (this.group_id) {
        this.$root.$confirm(this.$i18n.t('Delete'), this.$i18n.t('Delete Group') +" " + this.grp.code + "?", { color: "red" }).then((confirm) => {
          if (confirm) {
            this.$store.dispatch("deleteGroup", this.group_id);
            this.show = false;
            this.$emit("close");
          }
        });
      }
    },
  },
  created () {
    return this.grp = _.cloneDeep(this.$store.getters.getGroup(this.group_id));
  },
  // mounted: function () {
  //   document.addEventListener("keydown", (e) => {
  //     //Todo: use v-on:keyup.esc=NewFunction on the "dialog" div instead of this listner
  //     if (this.show && e.keyCode == 27) {
  //       if (this.group_id)
  //         this.grp = _.cloneDeep(this.$store.getters.getGroup(this.group_id));
  //       this.show = false;
  //       this.$emit("close");
  //     }
  //   });
  // }
}
</script>
<style scoped>
  input[type="number"] {
      -moz-appearance:textfield;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
</style>
